export default __webpack_public_path__ + "static/media/logo-portal-temp-1.21facaf3.png";